import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dd94bda"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "helper__move" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-left" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-chevron-right" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "nav__auth" }
const _hoisted_7 = {
  key: 0,
  class: "bg__btn",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal__auth"
}
const _hoisted_8 = {
  key: 1,
  class: "bg__btn dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false",
  "data-bs-offset": "0,10"
}
const _hoisted_9 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-right-from-bracket" }, null, -1))
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Log out ")
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "helper__button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleBack && _ctx.handleBack(...args)), ["prevent"]))
        }, _hoisted_3),
        _createElementVNode("button", {
          class: "helper__button",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleForward && _ctx.handleForward(...args)), ["prevent"]))
        }, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        (!_ctx.userLoggedIn)
          ? (_openBlock(), _createElementBlock("button", _hoisted_7, " Sign up / Log in "))
          : (_openBlock(), _createElementBlock("button", _hoisted_8, _toDisplayString(_ctx.userDisplayName), 1)),
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", null, [
            _createElementVNode("button", {
              class: "dropdown-item",
              type: "button",
              onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)), ["prevent"]))
            }, _hoisted_12)
          ])
        ])
      ])
    ]),
    _createVNode(_component_Modal)
  ], 64))
}